import { createStyles } from "@mantine/core";
const useStyles = createStyles((theme) => ({
  wrapper: {
    display: "flex",
  },
  content: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
  },
  btn: {
    marginLeft: "auto",
    marginTop: 50,
  },
  mymodal: {
    width: 818,
    // height: 800,
    "& .mantine-Modal-content": {
      height: "350px !important",
    },
    "& .mantine-Modal-inner": {
      padding: "0px !important",
    },

    "@media (max-width:400px)": {
      width: "auto",
    },
  },
  mwd: {
    width: "100%",
  },
  typeSelector: {
    paddingTop: 20,
    borderTopWidth: 1,
    borderTopColor: "#CBCBCB66",
    borderTopStyle: "solid",
    paddingBottom: 100,
  },
  noteTypeParent: {
    backgroundColor: "#fffff !important",
  },
}));

export default useStyles;
